import messages from './printscale-modal-translations';

export default {
    name: 'printscale-modal',
    i18n: {
        messages,
    },
    props: {
        show: {
            type: Boolean,
            default: true,
        },
        printScaleModalUrl: {
            type: String,
        },
    },
    methods: {
        dismiss: function () {
            this.$emit('closePrintScaleModal');
        },
    },
};



// WEBPACK FOOTER //
// ./src/map-viewer/components/printscale-modal/printscale-modal.js